module.exports = __webpack_public_path__ + "static/media/9DESA15.95fb195e.jpg";